module.exports = __webpack_public_path__ + "img/pic_channelSuccess.eba19151.png";